import {
  IEventListActionCreator,
  IEventListActionTypes,
  IEventListState,
} from "models/IEventState";

const initialState: IEventListState = {
  data: [],
};

const reducer = (state = initialState, { type, payload }: IEventListActionCreator) => {
  switch (type) {
    case IEventListActionTypes.FETCH_EVENT_LIST_REQUEST:
      return {
        ...state,
        data: [],
      };
    case IEventListActionTypes.FETCH_EVENT_LIST_SUCCESS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default reducer;
